import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "12",
  r: "8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 4.26v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z"
})), 'FiberSmartRecord');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FiberSmartRecord.js
// module id = 3890
// module chunks = 0